/* Infinixo v3 — storefront behaviour
   Vanilla JS, no dependencies. Everything degrades to a working
   server-rendered page when JS is unavailable. */
(function () {
  'use strict';

  var money = window.Infinixo && window.Infinixo.moneyFormat ? window.Infinixo.moneyFormat : '₹{{amount_no_decimals}}';
  var routes = (window.Infinixo && window.Infinixo.routes) || {};

  /* ---------- helpers -------------------------------------------------- */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var value = (cents || 0) / 100;
    function group(num, decimals) {
      // Indian digit grouping (##,##,###) — the store is INR.
      var fixed = Math.abs(num).toFixed(decimals);
      var parts = fixed.split('.');
      var int = parts[0];
      var last3 = int.slice(-3);
      var rest = int.slice(0, -3);
      if (rest) last3 = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + last3;
      return (num < 0 ? '-' : '') + last3 + (parts[1] ? '.' + parts[1] : '');
    }
    return money
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, group(value, 0))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, group(value, 2))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, group(value, 0))
      .replace(/\{\{\s*amount\s*\}\}/g, group(value, 2));
  }

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (r) {
      return r.json().then(function (body) {
        if (!r.ok) throw Object.assign(new Error(body.description || body.message || 'Request failed'), { body: body });
        return body;
      });
    });
  }

  /* ---------- toasts --------------------------------------------------- */

  var toastHost;
  function toast(text) {
    if (!text) return;
    if (!toastHost) {
      toastHost = document.createElement('div');
      toastHost.className = 'toast-host';
      toastHost.setAttribute('role', 'status');
      toastHost.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastHost);
    }
    var el = document.createElement('div');
    el.className = 'toast';
    el.textContent = text;
    toastHost.appendChild(el);
    setTimeout(function () {
      el.style.transition = 'opacity .3s ease';
      el.style.opacity = '0';
      setTimeout(function () { el.remove(); }, 320);
    }, 2600);
  }
  window.Infinixo = window.Infinixo || {};
  window.Infinixo.toast = toast;

  /* ---------- cart ----------------------------------------------------- */

  var Cart = {
    listeners: [],
    onChange: function (fn) { this.listeners.push(fn); },
    emit: function (cart) { this.listeners.forEach(function (fn) { fn(cart); }); },

    get: function () {
      return fetchJSON((routes.cart_url || '/cart') + '.js');
    },

    /* items: [{id, quantity, properties}] */
    add: function (items) {
      return fetchJSON((routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function () {
        return Cart.get();
      }).then(function (cart) {
        Cart.emit(cart);
        return cart;
      });
    },

    change: function (key, quantity) {
      return fetchJSON((routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (cart) {
        Cart.emit(cart);
        return cart;
      });
    }
  };
  window.Infinixo.Cart = Cart;

  function renderCartCount(cart) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    $$('[data-cart-count-bracket]').forEach(function (el) { el.textContent = '(' + cart.item_count + ')'; });
  }

  /* ---------- cart drawer ---------------------------------------------- */

  var drawer, lastFocus;

  function drawerOpen() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    document.body.style.overflow = 'hidden';
    var close = $('[data-drawer-close]', drawer);
    if (close) close.focus();
  }

  function drawerClose() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function refreshDrawer() {
    if (!drawer) return Promise.resolve();
    var body = $('[data-drawer-body]', drawer);
    if (body) body.classList.add('is-busy');
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = $('[data-drawer-inner]', doc);
        var current = $('[data-drawer-inner]', drawer);
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* leave the stale render in place */ })
      .then(function () { if (body) body.classList.remove('is-busy'); });
  }

  function initDrawer() {
    drawer = $('[data-cart-drawer]');
    if (!drawer) return;

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); drawerOpen(); return; }
      if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-scrim]')) {
        e.preventDefault(); drawerClose();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) drawerClose();
    });

    /* Quantity + remove inside the drawer (event-delegated, survives re-render) */
    drawer.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      var remove = e.target.closest('[data-line-remove]');
      var row = e.target.closest('[data-line-key]');
      if (!row) return;
      var key = row.getAttribute('data-line-key');

      if (remove) {
        e.preventDefault();
        row.classList.add('is-busy');
        Cart.change(key, 0).then(refreshDrawer);
        return;
      }
      if (step) {
        e.preventDefault();
        var input = $('input[data-qty-input]', row);
        var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty-step'), 10));
        row.classList.add('is-busy');
        Cart.change(key, next).then(refreshDrawer);
      }
    });

    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('input[data-qty-input]');
      if (!input) return;
      var row = input.closest('[data-line-key]');
      row.classList.add('is-busy');
      Cart.change(row.getAttribute('data-line-key'), Math.max(0, parseInt(input.value, 10) || 0)).then(refreshDrawer);
    });

    Cart.onChange(function (cart) {
      renderCartCount(cart);
      refreshDrawer().then(function () {
        if (window.Infinixo.cartDrawer !== false) drawerOpen();
      });
    });
  }

  /* ---------- add-to-cart forms ---------------------------------------- */

  function initAddForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();

      var btn = form.querySelector('[type="submit"]');
      var items = [];
      var bundle = form.getAttribute('data-bundle-ids'); /* "id:qty,id:qty" — layering duos */

      if (bundle) {
        bundle.split(',').forEach(function (pair) {
          var bits = pair.split(':');
          if (bits[0]) items.push({ id: Number(bits[0]), quantity: Number(bits[1] || 1) });
        });
      } else {
        var idField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('[name="quantity"]');
        if (!idField || !idField.value) return;
        items.push({ id: Number(idField.value), quantity: Number(qtyField ? qtyField.value : 1) || 1 });
      }
      if (!items.length) return;

      if (btn) { btn.classList.add('is-busy'); btn.disabled = true; }
      Cart.add(items)
        .then(function () { toast(form.getAttribute('data-added-text') || 'Added to your cart.'); })
        .catch(function (err) { toast(err.message || 'Could not add that right now.'); })
        .then(function () { if (btn) { btn.classList.remove('is-busy'); btn.disabled = false; } });
    });
  }

  /* ---------- PDP: size selector --------------------------------------- */

  function initProductForm() {
    $$('[data-product-form]').forEach(function (form) {
      var variants = readJSON(form.getAttribute('data-variants-id')) || [];
      var idField = $('[name="id"]', form);
      var submit = $('[data-add-label]', form);
      var buttons = $$('[data-variant-pick]', form);

      function select(id) {
        var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!v) return;
        idField.value = v.id;
        buttons.forEach(function (b) {
          b.setAttribute('aria-pressed', String(String(b.getAttribute('data-variant-pick')) === String(v.id)));
        });
        if (submit) {
          if (v.available) {
            submit.textContent = (submit.getAttribute('data-add-label') || 'Add to cart') + ' — ' + formatMoney(v.price);
            submit.disabled = false;
          } else {
            submit.textContent = submit.getAttribute('data-sold-label') || 'Sold out';
            submit.disabled = true;
          }
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }

      buttons.forEach(function (b) {
        b.addEventListener('click', function () { select(b.getAttribute('data-variant-pick')); });
      });

      var initial = new URL(window.location.href).searchParams.get('variant');
      if (initial && variants.some(function (v) { return String(v.id) === initial; })) select(initial);
      else if (idField && idField.value) select(idField.value);
    });
  }

  /* ---------- PDP: gallery thumbs -------------------------------------- */

  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var main = $('[data-gallery-main]', gallery);
      $$('[data-gallery-thumb]', gallery).forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          main.src = thumb.getAttribute('data-gallery-thumb');
          main.srcset = '';
          $$('[data-gallery-thumb]', gallery).forEach(function (t) {
            t.setAttribute('aria-pressed', String(t === thumb));
          });
        });
      });
    });
  }

  /* ---------- Layer builder -------------------------------------------- */

  function initLayerBuilder() {
    var root = $('[data-layer-builder]');
    if (!root) return;
    var scents = readJSON(root.getAttribute('data-scents-id')) || [];
    var panel = $('[data-builder-panel]', root);
    var hint = $('[data-builder-hint]', root);
    var hintIdle = hint ? hint.textContent : '';

    function byHandle(h) { return scents.filter(function (s) { return s.handle === h; })[0]; }

    function render(handle) {
      var a = byHandle(handle);
      if (!a || !panel) return;

      var partners = (a.partners || []).map(byHandle).filter(Boolean);
      var rows = partners.map(function (q) {
        var full = (a.price || 0) + (q.price || 0);
        var price = full - (window.Infinixo.pairSaving || 0);
        if (price < 0) price = full;
        var ids = (a.variantId && q.variantId) ? a.variantId + ':1,' + q.variantId + ':1' : '';
        var cta = ids
          ? '<form method="post" action="' + (routes.cart_add_url || '/cart/add') + '" data-ajax-cart data-bundle-ids="' + ids + '"' +
            ' data-added-text="' + esc(a.title + ' + ' + q.title + ' added to your cart.') + '">' +
            '<button type="submit" class="btn btn--accent btn--sm">' + esc(formatMoney(price)) + '</button></form>'
          : '<a class="btn btn--outline btn--sm" href="/products/' + esc(q.handle) + '">View</a>';
        return '<div class="partner">' +
          (q.image ? '<img src="' + esc(q.image) + '" alt="" loading="lazy" width="44" height="44">' : '') +
          '<span style="flex:1"><span class="partner__name">' + esc(q.title) + '</span>' +
          '<span class="partner__meta">' + esc(q.effect || q.family || '') + '</span></span>' +
          cta + '</div>';
      }).join('');

      panel.innerHTML =
        '<p class="eyebrow" style="margin-bottom:4px">Base layer</p>' +
        '<h3 class="builder__name">' + esc(a.title) + '</h3>' +
        '<p class="builder__text">' + esc(a.layerText || '') + '</p>' +
        '<div class="partners">' + rows + '</div>';
      panel.hidden = false;
      if (hint) hint.textContent = 'Tap another scent to swap your base layer.';
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    $$('[data-pick-base]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('[data-pick-base]', root).forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
        render(btn.getAttribute('data-pick-base'));
      });
    });

    if (panel) { panel.hidden = true; if (hint) hint.textContent = hintIdle; }
  }

  /* ---------- Find Your Version quiz -------------------------------------
     Five questions, one per group in quiz-data (snippets/quiz-data.liquid,
     generated from scripts/quiz-data.mjs). Question 1 is random; each later
     one is picked at random among those that best separate the current
     leaders. scripts/simulate-quiz.mjs mirrors this logic — keep them in
     step. The name stays in this browser and on the cart; it is never sent
     to analytics. */

  var QUIZ_STORE = 'infinixo-quiz';
  /* Keep in step with QUIZ_KEY in scripts/generate-quiz-data.mjs. */
  var QUIZ_KEY = 'every-version-of-me';

  /* snippets/quiz-data.liquid holds the quiz scrambled (XOR + base64) so the
     scores aren't readable in the page source at a glance. */
  function readQuizData(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      var raw = atob(el.textContent.trim());
      var bytes = new Uint8Array(raw.length);
      for (var i = 0; i < raw.length; i++) bytes[i] = raw.charCodeAt(i) ^ QUIZ_KEY.charCodeAt(i % QUIZ_KEY.length);
      return JSON.parse(new TextDecoder().decode(bytes));
    } catch (e) { return null; }
  }

  function quizStore(value) {
    try {
      if (value === undefined) return JSON.parse(localStorage.getItem(QUIZ_STORE) || 'null');
      localStorage.setItem(QUIZ_STORE, JSON.stringify(value));
    } catch (e) { return null; }
  }

  function quizTrack(name, data) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data);
    } catch (e) { /* analytics must never break the quiz */ }
  }

  function fill(template, vars) {
    return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, k) { return vars[k] == null ? '' : vars[k]; });
  }

  function escHTML(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function initVersionQuiz() {
    var root = $('[data-version-quiz]');
    var data = readQuizData('quiz-data');
    var perfumes = readJSON('quiz-perfumes');
    var t = readJSON('quiz-strings') || {};
    if (!root || !data || !perfumes || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', 'true');

    var panels = { start: $('[data-vq-start]', root), name: $('[data-vq-name-step]', root), question: $('[data-vq-question]', root), result: $('[data-vq-result]', root) };
    var nameInput = $('[data-vq-name]', root);
    var handles = Object.keys(perfumes);
    var groupQs = {};
    data.groups.forEach(function (g) { groupQs[g] = data.questions.filter(function (q) { return q.group === g; }); });

    var state, undo;
    var saved = quizStore() || {};
    if (saved.name) nameInput.value = saved.name;

    var visual = $('[data-vq-visual]', root);
    var waitEl = $('[data-vq-wait]', root);
    var picksEl = $('[data-vq-picks]', root);
    var afterEl = $('[data-vq-after]', root);

    /* While answering, the right-hand side is an outlined placeholder with
       the mark breathing; on the result it shows the perfume brief(s) and
       Save your version appears. */
    function show(which) {
      Object.keys(panels).forEach(function (k) { panels[k].hidden = k !== which; });
      var result = which === 'result';
      root.classList.toggle('is-result', result);
      if (waitEl) waitEl.hidden = result;
      if (picksEl) {
        picksEl.hidden = !result;
        if (!result) picksEl.innerHTML = '';
      }
      if (afterEl && !result) afterEl.hidden = true;
    }

    /* Restart the entrance animation so each question arrives fresh. */
    function arrive(el) {
      el.classList.remove('is-in');
      void el.offsetWidth;
      el.classList.add('is-in');
    }

    function fresh(name) {
      var totals = {};
      handles.forEach(function (h) { totals[h] = 0; });
      return { name: name, step: 0, totals: totals, want: {}, shifts: [], excluded: [], picks: [], current: null };
    }

    function ranked(s) {
      return handles.slice().sort(function (a, b) {
        return (s.totals[b] - s.totals[a]) || ((s.want[b] || 0) - (s.want[a] || 0));
      });
    }

    function pickQuestion(s) {
      var group = data.groups[s.step];
      var qs = groupQs[group];
      if (s.step === 0) return qs[Math.floor(Math.random() * qs.length)];
      var top = ranked(s).slice(0, 3);
      var scored = qs.map(function (q) {
        var spread = 0;
        q.answers.forEach(function (a) {
          var vals = top.map(function (h) { return a.scores[h] || 0; });
          var mean = vals.reduce(function (x, v) { return x + v; }, 0) / vals.length;
          spread += vals.reduce(function (x, v) { return x + (v - mean) * (v - mean); }, 0);
        });
        return { q: q, spread: spread };
      });
      var best = Math.max.apply(null, scored.map(function (x) { return x.spread; }));
      var near = scored.filter(function (x) { return x.spread >= data.nearBest * best; });
      return near[Math.floor(Math.random() * near.length)].q;
    }

    /* The name counts as question 1, so the quiz reads "1 of 6". */
    var totalSteps = data.groups.length + 1;

    function askName() {
      $('[data-vq-name-count]', root).textContent = fill(t.step, { current: 1, total: totalSteps });
      $('[data-vq-name-bar]', root).style.width = '0%';
      show('name');
      nameInput.focus({ preventScroll: true });
    }

    function paintQuestion() {
      var q = state.current;
      $('[data-vq-step]', root).textContent = fill(t.step, { current: state.step + 2, total: totalSteps });
      $('[data-vq-bar]', root).style.width = (((state.step + 1) / totalSteps) * 100) + '%';
      $('[data-vq-text]', root).textContent = q.text;
      var opts = $('[data-vq-options]', root);
      opts.innerHTML = '';
      q.answers.forEach(function (a, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'vquiz__opt';
        b.textContent = a.label;
        b.addEventListener('click', function () { answer(i); });
        opts.appendChild(b);
      });
      show('question');
      arrive(panels.question);
      $('[data-vq-text]', root).focus({ preventScroll: true });
    }

    function begin(name) {
      state = fresh(name);
      undo = [];
      state.current = pickQuestion(state);
      paintQuestion();
    }

    function answer(i) {
      var q = state.current;
      var a = q.answers[i];
      undo.push(JSON.stringify(state));
      Object.keys(a.scores).forEach(function (h) {
        if (!(h in state.totals)) return;
        state.totals[h] += a.scores[h];
        if (q.group === 'want') state.want[h] = (state.want[h] || 0) + a.scores[h];
      });
      if (a.shift) state.shifts.push(a.shift);
      if (a.exclude) state.excluded = state.excluded.concat(a.exclude);
      state.picks.push(a.label);
      quizTrack('quiz_answered', { question: q.id, answer: i, step: state.step + 1 });
      state.step += 1;
      if (state.step >= data.groups.length) return finish();
      state.current = pickQuestion(state);
      paintQuestion();
    }

    function back() {
      if (!undo.length) return askName();
      state = JSON.parse(undo.pop());
      paintQuestion();
    }

    function decide(s) {
      var order = ranked(s).filter(function (h) { return s.excluded.indexOf(h) === -1; });
      var win = order[0], second = order[1];
      if (s.totals[win] > 0 && s.totals[second] >= data.closeSecond * s.totals[win]) {
        return { win: win, second: second, kind: 'close' };
      }
      var shift = s.shifts[s.shifts.length - 1];
      if (shift) {
        var partner = (perfumes[win].partners || []).filter(function (h) {
          return h !== win && s.excluded.indexOf(h) === -1 && (data.shiftPartners[shift] || []).indexOf(h) !== -1 && perfumes[h];
        })[0];
        if (partner) return { win: win, second: partner, kind: 'layer', shift: shift };
      }
      return { win: win, kind: 'single' };
    }

    function finish() {
      var r = decide(state);
      r.name = state.name;
      r.picks = state.picks.slice(0, 3);
      quizStore({ name: state.name, result: r, at: Date.now() });
      quizTrack('quiz_completed', { version: r.win, second: r.second || null, kind: r.kind });
      saveToCart(r);
      renderResult(r, false, true);
      celebrate();
    }

    /* The name and version ride along on the order, so they show in the admin. */
    function saveToCart(r) {
      var p = perfumes[r.win];
      fetch((routes.cart_url || '/cart') + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { 'Quiz name': r.name || '', 'Quiz version': p.phrase, 'Quiz perfume': p.title } })
      }).catch(function () { /* not worth interrupting the result for */ });
    }

    /* A short brief on a recommended perfume, linking to its product page. */
    function brief(h, label, lead) {
      var p = perfumes[h];
      return '<article class="vq-pick' + (lead ? ' vq-pick--lead' : '') + '">' +
        (p.image ? '<a class="vq-pick__media" href="' + p.url + '" tabindex="-1" aria-hidden="true"><img src="' + p.image + '" alt="" width="900" height="968" loading="lazy"></a>' : '') +
        '<div class="vq-pick__body">' +
          '<p class="eyebrow eyebrow--pop">' + escHTML(label) + '</p>' +
          '<h3 class="vq-pick__name"><a href="' + p.url + '">' + escHTML(p.title) + '</a></h3>' +
          (p.family ? '<p class="vq-pick__family">' + escHTML(p.family) + '</p>' : '') +
          (p.oneLiner ? '<p class="vq-pick__line">' + escHTML(p.oneLiner) + '</p>' : '') +
          '<a class="btn ' + (lead ? 'btn--ink' : 'btn--outline') + ' btn--sm vq-pick__go" href="' + p.url + '">' +
            escHTML(fill(t.discover, { title: p.title })) + ' <span aria-hidden="true">→</span></a>' +
        '</div>' +
      '</article>';
    }

    function renderResult(r, shared, reveal) {
      var p = perfumes[r.win];
      if (!p) return begin('');
      var head = shared ? t.shared_headline : (r.name ? fill(t.headline_named, { name: escHTML(r.name) }) : t.headline);
      var html = '<p class="eyebrow">' + head + '</p>' +
        '<h2 class="vquiz__phrase' + (reveal ? ' is-reveal' : '') + '">' + phraseWords(p.phrase) + '</h2>' +
        (p.feels ? '<p class="vquiz__feels">' + escHTML(p.feels) + '</p>' : '');
      if (!shared && r.picks && r.picks.length) {
        html += '<p class="vquiz__because">' + escHTML(t.because) + '</p><ul class="vquiz__picks">' +
          r.picks.map(function (l) { return '<li class="pill">' + escHTML(l) + '</li>'; }).join('') + '</ul>';
      }
      if (shared) html += '<button type="button" class="btn btn--pop btn--lg vquiz__own" data-vq-retake>' + escHTML(t.take_quiz) + ' <span aria-hidden="true">→</span></button>';

      var body = $('[data-vq-result-body]', root);
      body.innerHTML = html;

      var picks = brief(r.win, t.your_perfume, true);
      if (r.second && perfumes[r.second]) picks += brief(r.second, t.also_you, false);
      if (picksEl) picksEl.innerHTML = picks;

      var tags = $('[data-vq-keep-tags]', root);
      if (tags) tags.value = 'quiz, quiz-' + r.win.replace(/-eau-de-parfum$/, '');
      var nameField = $('[data-vq-keep-name]', root);
      if (nameField) nameField.value = r.name || '';
      show('result');
      if (afterEl) afterEl.hidden = !!shared;
      if (visual && reveal) arrive(visual);
      window.scrollTo({ top: 0, behavior: 'smooth' });
      body.focus({ preventScroll: true });
    }

    /* Each word of the version rises in turn on a fresh result. */
    function phraseWords(phrase) {
      phrase = String(phrase || '');
      phrase = phrase.charAt(0).toUpperCase() + phrase.slice(1);
      return phrase.split(' ').map(function (w, i) {
        return '<span style="animation-delay:' + (0.25 + i * 0.12).toFixed(2) + 's">' + escHTML(w) + '</span>';
      }).join(' ');
    }

    /* A short burst of confetti in the brand colours when a version is found. */
    function celebrate() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var styles = getComputedStyle(document.documentElement);
      var colours = ['--pop', '--ink', '--accent', '--soft'].map(function (v) { return styles.getPropertyValue(v).trim() || '#F49883'; });
      var canvas = document.createElement('canvas');
      canvas.className = 'vquiz__confetti';
      canvas.setAttribute('aria-hidden', 'true');
      document.body.appendChild(canvas);
      var ctx = canvas.getContext('2d');
      var dpr = window.devicePixelRatio || 1;
      var w = window.innerWidth, h = window.innerHeight;
      canvas.width = w * dpr; canvas.height = h * dpr;
      ctx.scale(dpr, dpr);
      var bits = [];
      for (var i = 0; i < 150; i++) {
        var fromLeft = i % 2 === 0;
        bits.push({
          x: fromLeft ? -10 : w + 10,
          y: h * (0.55 + Math.random() * 0.3),
          vx: (fromLeft ? 1 : -1) * (6 + Math.random() * 9),
          vy: -(10 + Math.random() * 10),
          size: 6 + Math.random() * 7,
          spin: Math.random() * Math.PI,
          vspin: (Math.random() - 0.5) * 0.3,
          colour: colours[i % colours.length],
          round: Math.random() < 0.3
        });
      }
      var start = null;
      function frame(ts) {
        if (start === null) start = ts;
        var t = ts - start;
        ctx.clearRect(0, 0, w, h);
        ctx.globalAlpha = t > 1800 ? Math.max(0, 1 - (t - 1800) / 600) : 1;
        bits.forEach(function (b) {
          b.vy += 0.38; b.vx *= 0.985; b.x += b.vx; b.y += b.vy; b.spin += b.vspin;
          ctx.save();
          ctx.translate(b.x, b.y);
          ctx.rotate(b.spin);
          ctx.fillStyle = b.colour;
          if (b.round) { ctx.beginPath(); ctx.arc(0, 0, b.size / 2.4, 0, Math.PI * 2); ctx.fill(); }
          else ctx.fillRect(-b.size / 2, -b.size / 4, b.size, b.size / 2);
          ctx.restore();
        });
        if (t < 2400) requestAnimationFrame(frame);
        else canvas.remove();
      }
      requestAnimationFrame(frame);
    }


    /* Returning visitors who gave a name are greeted by it on the start screen. */
    function welcome() {
      var el = $('[data-vq-welcome]', root);
      var name = (quizStore() || {}).name;
      if (!el) return;
      el.textContent = name ? fill(t.welcome_back, { name: name }) : '';
      el.hidden = !name;
    }

    /* ---- events ---- */

    function startQuiz() {
      quizTrack('quiz_started', {});
      askName();
    }
    $('[data-vq-begin]', root).addEventListener('click', startQuiz);
    $('[data-vq-name-form]', root).addEventListener('submit', function (e) {
      e.preventDefault();
      begin(nameInput.value.trim().slice(0, 40));
    });
    $('[data-vq-skip]', root).addEventListener('click', function () { begin(''); });
    $('[data-vq-back]', root).addEventListener('click', back);

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-vq-retake]')) {
        if (window.location.search) window.history.replaceState(null, '', window.location.pathname);
        welcome();
        show('start');
        return;
      }
      if (e.target.closest('[data-vq-share]')) {
        var r = (quizStore() || {}).result;
        if (!r || !perfumes[r.win]) return;
        var url = root.getAttribute('data-share-url') + '?v=' + encodeURIComponent(r.win);
        var text = fill(t.share_text, { phrase: perfumes[r.win].phrase });
        if (navigator.share) navigator.share({ text: text, url: url }).catch(function () {});
        else if (navigator.clipboard) navigator.clipboard.writeText(text + ' ' + url).then(function () { toast(t.copied); });
      }
    });

    /* Phone is optional; when given, send it as +91XXXXXXXXXX. Shopify's
       hCaptcha takes over the form's submit, so this runs as the person
       types and lets native validation block a bad number. */
    var keepForm = $('.vquiz__keep-form', root);
    var phone = keepForm && $('[data-vq-keep-phone]', keepForm);
    var phoneE164 = keepForm && $('[data-vq-keep-phone-e164]', keepForm);
    if (phone && phoneE164) {
      phone.addEventListener('input', function () {
        var raw = phone.value.trim();
        var digits = raw.replace(/\D/g, '').replace(/^(91|0)(?=\d{10}$)/, '');
        var ok = !raw || /^[6-9]\d{9}$/.test(digits);
        phone.setCustomValidity(ok ? '' : t.phone_invalid);
        phoneE164.value = ok && raw ? '+91' + digits : '';
        phoneE164.disabled = !phoneE164.value;
      });
      phoneE164.disabled = true;
      keepForm.addEventListener('submit', function () { quizTrack('quiz_contact_saved', { phone: !phoneE164.disabled }); });
    }

    /* ---- entry points ---- */

    var params = new URLSearchParams(window.location.search);
    var sharedHandle = params.get('v');
    if (sharedHandle && perfumes[sharedHandle]) return renderResult({ win: sharedHandle, kind: 'single' }, true);
    /* "Start the quiz" on the homepage lands here with ?start=1 and skips the start screen. */
    if (params.get('start')) {
      window.history.replaceState(null, '', window.location.pathname);
      return startQuiz();
    }
    if ($('[data-vq-posted]', root) || $('.vquiz__keep-error', root)) {
      if (saved.result) return renderResult(saved.result, false);
    }
    welcome();
    show('start');
  }

  /* ---------- alternating feed cards ------------------------------------
     Design flips image/text sides every other feed card at >=900px via
     flex `order` (Infinixo Storefront.dc.html applyLayout()); below that
     it's always image-first. Mirrors it here since it's index-driven JS
     in the design, not something a static template/CSS rule expresses. */

  function applyAltFeed() {
    var wide = window.innerWidth >= 900;
    $$('.pcard__row').forEach(function (row, i) {
      var media = $('.pcard__media', row);
      var body = $('.pcard__body', row);
      if (!media || !body) return;
      media.style.order = wide ? (i % 2 ? '2' : '0') : '';
      body.style.order = wide ? '1' : '';
    });
  }

  /* ---------- scroll reveal -----------------------------------------------
     [data-reveal] sections start hidden (opacity:0) via CSS. Anything
     already in the initial viewport gets revealed instantly with no
     transition so nothing fades in without the user actually scrolling;
     everything else fades in once it enters view. */

  function initReveal() {
    var els = $$('[data-reveal]');
    if (!els.length) return;
    if (!window.IntersectionObserver) {
      els.forEach(function (el) { el.classList.add('is-revealed', 'no-anim'); });
      return;
    }
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var toObserve = [];
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < vh && r.bottom > 0) {
        el.classList.add('is-revealed', 'no-anim');
      } else {
        toObserve.push(el);
      }
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -10% 0px' });
    toObserve.forEach(function (el) { io.observe(el); });
  }

  /* ---------- product tiles: image slider and size picker --------------- */

  function initTiles() {
    $$('[data-tile]').forEach(function (tile) {
      if (tile.dataset.bound) return;
      tile.dataset.bound = '1';

      var track = $('[data-tile-slides]', tile);
      var dots = $$('[data-tile-dot]', tile);
      if (track && dots.length) {
        var slides = $$('.tile__slide', track);
        var mark = function (i) {
          dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
          slides.forEach(function (s, n) { s.tabIndex = n === i ? 0 : -1; });
        };
        track.addEventListener('scroll', function () {
          mark(Math.round(track.scrollLeft / track.clientWidth));
        }, { passive: true });
        dots.forEach(function (dot) {
          dot.addEventListener('click', function () {
            track.scrollTo({ left: track.clientWidth * Number(dot.dataset.tileDot), behavior: 'smooth' });
          });
        });
      }

      var idField = $('[name="id"]', tile);
      var price = $('[data-tile-price]', tile);
      var add = $('[data-tile-add]', tile);
      var sizes = $$('[data-tile-variant]', tile);
      sizes.forEach(function (btn) {
        btn.addEventListener('click', function () {
          sizes.forEach(function (b) { b.setAttribute('aria-pressed', String(b === btn)); });
          idField.value = btn.dataset.tileVariant;
          if (price) price.textContent = btn.dataset.price;
          var available = btn.dataset.available === 'true';
          add.disabled = !available;
          add.textContent = available ? add.dataset.addLabel : add.dataset.soldLabel;
        });
      });
    });
  }

  /* ---------- sticky header: glass once the page scrolls ---------------- */

  function initHeaderGlass() {
    var header = $('.site-header');
    if (!header || header.dataset.bound) return;
    header.dataset.bound = '1';
    var ticking = false;
    function update() {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------- hero slider ----------------------------------------------- */

  /* Homepage hero: fades between slides every data-interval seconds.
     Pauses while hovered, focused or the tab is hidden; never auto-rotates
     for reduced motion. Only the visible slide's links are focusable. */
  function initHeroSlider() {
    document.querySelectorAll('[data-hero-slider]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
      var interval = (parseInt(root.dataset.interval, 10) || 6) * 1000;
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var index = 0;
      var timer = null;
      var paused = false;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (slide, n) {
          var on = n === index;
          slide.classList.toggle('is-active', on);
          slide.setAttribute('aria-hidden', on ? 'false' : 'true');
          slide.querySelectorAll('a, button').forEach(function (el) {
            if (on) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
          });
        });
        dots.forEach(function (dot, n) {
          dot.classList.toggle('is-active', n === index);
          if (n === index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
        });
      }
      function stop() { clearInterval(timer); timer = null; }
      function start() {
        stop();
        if (reduced || paused || document.hidden) return;
        timer = setInterval(function () { show(index + 1); }, interval);
      }
      function pause(on) { paused = on; start(); }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { show(parseInt(dot.dataset.heroDot, 10)); start(); });
      });
      root.addEventListener('mouseenter', function () { pause(true); });
      root.addEventListener('mouseleave', function () { pause(false); });
      root.addEventListener('focusin', function () { pause(true); });
      root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) pause(false); });
      document.addEventListener('visibilitychange', start);

      /* Theme editor: jump to a slide block when it is selected. */
      root.addEventListener('shopify:block:select', function (e) {
        var n = slides.indexOf(e.target);
        if (n > -1) { show(n); pause(true); }
      });
      root.addEventListener('shopify:block:deselect', function () { pause(false); });

      show(0);
      start();
    });
  }

  /* ---------- boot ------------------------------------------------------ */

  function boot() {
    initHeaderGlass();
    initHeroSlider();
    initTiles();
    initDrawer();
    initAddForms();
    initProductForm();
    initGallery();
    initLayerBuilder();
    initVersionQuiz();
    applyAltFeed();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('resize', applyAltFeed);

  /* Theme editor: re-bind after a section is re-rendered. */
  document.addEventListener('shopify:section:load', boot);
})();
